export async function storeproviders() {
    const { ProviderTheme, ProviderLanguage ,ProviderToken} = await import('./store');
  
    return [ProviderTheme, ProviderLanguage,ProviderToken];
  }
  